import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "text-lg" }
const _hoisted_2 = ["aria-expanded", "onClick"]
const _hoisted_3 = { class: "font-semibold text-gray-200 flex items-start" }
const _hoisted_4 = { class: "ml-6 h-6 flex items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M19 9l-7 7-7-7"
}, null, -1)
const _hoisted_6 = [
  _hoisted_5
]


export default /*#__PURE__*/_defineComponent({
  __name: 'Accordion',
  props: {
  sm: Boolean,
  isOpen: Boolean
},
  emits: ["panel:toggle"],
  setup(__props, { emit }: { emit: ({
  (e: 'panel:toggle'): void
}), expose: any, slots: any, attrs: any }) {





function handleToggle() {
  emit('panel:toggle')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
      'pt-6': !__props.sm,
      'py-2 px-6': __props.sm
    })
  }, [
    _createElementVNode("dt", _hoisted_1, [
      _createElementVNode("button", {
        class: _normalizeClass(["text-left w-full flex justify-between items-start text-gray-200", {
          'items-center': __props.sm
        }]),
        "aria-expanded": __props.isOpen,
        onClick: _withModifiers(handleToggle, ["stop"])
      }, [
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "title"),
          _renderSlot(_ctx.$slots, "badge")
        ]),
        _createElementVNode("span", _hoisted_4, [
          (_openBlock(), _createElementBlock("svg", {
            class: _normalizeClass(["transform", {
              'h-6 w-6': !__props.sm,
              'h-4 w-4': __props.sm,
              'rotate-180': __props.isOpen
            }]),
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 24 24",
            stroke: "currentColor",
            "aria-hidden": "true"
          }, _hoisted_6, 2))
        ])
      ], 10, _hoisted_2)
    ]),
    _withDirectives(_createElementVNode("dd", {
      class: _normalizeClass(["mt-2", {
        'pr-12': !__props.sm
      }])
    }, [
      _renderSlot(_ctx.$slots, "content")
    ], 2), [
      [_vShow, __props.isOpen]
    ])
  ], 2))
}
}

})